module.exports = __webpack_public_path__ + "02_medium_gray.787dcee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_medium_gray.png
// module id = oOSz
// module chunks = 0